<div class="grid-container">
	<div class="jaw-data">
		<h3>{{"Digital jaw data" | translate}}</h3>
		<h3>{{"Bite in HIKP" | translate}}</h3>
		<ux-upload-stl
			[patientId]="patientId"
			[isRequiredUpperJaw]="true"
			[isRequiredLowerJaw]="true"
			[showUploadHints]="false"
			[onFileEventFunction]="onFileEvent"
			[orcadentJawDataType]="OrcadentJawDataType.BITE"
			[uploadedFiles]="uploadedBiteFiles"
			(action)="onAction($event)"
			data-cy="hikp-bite-stl-uploads"
		></ux-upload-stl>
		<h3>{{"Registration bite" | translate}}  (optional)</h3>
		<ux-upload-stl
			[patientId]="patientId"
			[isRequiredUpperJaw]="false"
			[isRequiredLowerJaw]="false"
			[onFileEventFunction]="onFileEvent"
			[orcadentJawDataType]="OrcadentJawDataType.REGISTRATION"
			[uploadedFiles]="uploadedRegistrationFiles"
			(action)="onAction($event)"
			data-cy="registration-stl-uploads"
		></ux-upload-stl>
	</div>
	<div>
		<anamnese-orcadent-images
			[patientId]="patientId"
			[uploadedImageFiles]="uploadedImageFiles"
		>
		</anamnese-orcadent-images>
	</div>

	<ux-next-back-actions
		(action)="onAction($event)"
		[disabledNext]="disableNext"
	></ux-next-back-actions>
</div>

